import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import ArticleSection from './components/ArticleSection';
import TrustSection from './components/TrustSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <CTASection />
      <ArticleSection />
      <TrustSection />
      <Footer />
    </main>
  );
}